(function(){
"use strict";

/* Sections in a Shopify theme can be removed, reordered or simply not added.
   Every lookup below therefore has to tolerate a missing element — `on()`
   quietly does nothing when the target isn't on the page. */
function on(el, ev, fn, opts){ if(el && el.addEventListener) el.addEventListener(ev, fn, opts); }
var reduced = window.matchMedia('(prefers-reduced-motion: reduce)').matches;
var $ = function(id){ return document.getElementById(id); };

/* ---------- Header ---------- */
var header = $('siteHeader');
function onScrollHeader(){
  if(!header) return;
  header.classList.toggle('scrolled', window.scrollY > 24);
}
if(header){
  window.addEventListener('scroll', onScrollHeader, {passive:true});
  onScrollHeader();
}

/* ---------- Mobile menu ---------- */
var menuBtn = $('menuBtn'), mobileMenu = $('mobileMenu');
function setMenu(open){
  if(!mobileMenu) return;
  mobileMenu.classList.toggle('open', open);
  mobileMenu.setAttribute('aria-hidden', String(!open));
  if(menuBtn) menuBtn.setAttribute('aria-expanded', String(open));
}
on(menuBtn, 'click', function(){ setMenu(!mobileMenu.classList.contains('open')); });
on(mobileMenu, 'click', function(e){ if(e.target === mobileMenu || e.target.tagName === 'A') setMenu(false); });
document.addEventListener('keydown', function(e){ if(e.key === 'Escape'){ setMenu(false); setCart(false); }});

/* ---------- Reveal on scroll ---------- */
var io = new IntersectionObserver(function(entries){
  entries.forEach(function(en){ if(en.isIntersecting){ en.target.classList.add('in'); io.unobserve(en.target); } });
},{threshold:.14, rootMargin:'0px 0px -6% 0px'});
document.querySelectorAll('.rv').forEach(function(el){ io.observe(el); });

/* ---------- Hero scroll movie ----------
   The film is scrubbed by scroll position, but the mapping is deliberately
   NON-linear: each entry in `beats` is a frame the movie settles on, and its
   `hold` value is how much scroll is spent frozen there. Between beats the
   film runs; on a beat it pauses while the visitor keeps scrolling.

   There are two cuts of the same edit — 16:9 for landscape viewports and 9:16
   for portrait ones — so a phone gets a full-bleed film instead of a
   letterboxed strip. They run at slightly different lengths, so each carries
   its own beat map.                                                        */
var heroTrack = document.querySelector('.hero-track'),
    film      = $('heroFilm'),
    heroScrim = $('heroScrim'),
    heroBoot  = $('heroBoot'),
    heroCopy  = $('heroCopy'),
    heroEnd   = $('heroEnd'),
    heroCue   = $('heroCue'),
    heroBar   = $('heroBar'),
    heroNum   = $('heroNum'),
    heroL1    = $('heroL1'),
    heroL2    = $('heroL2'),
    chapEls   = Array.prototype.slice.call(document.querySelectorAll('#heroChapters li'));

var FILMS = {
  landscape: {
    dataId: 'heroFilmData',
    beats: [
      { t: 0.60,  hold: 0.80 },   /* 01 Reveal  — product + balm smear, headline reads here */
      { t: 5.20,  hold: 0.85 },   /* 02 Ritual  — "Meet your one-swipe glow ritual"         */
      { t: 6.30,  hold: 0.60 },   /* 03 Swipe   — the balm meets skin                        */
      { t: 7.75,  hold: 0.75 },   /* 04 Hydrate — droplet world                              */
      { t: 9.20,  hold: 0.70 },   /* 05 Smooth  — skin texture                               */
      { t: 10.25, hold: 0.70 },   /* 06 Soften  — one stick, so many ways to glow            */
      { t: 12.50, hold: 0.85 },   /* 07 Glow    — apply to targeted areas / radiant          */
      { t: 15.60, hold: 0.80 }    /* 08 Results — closing card; hold kept short so the page
                                     releases into the next section without a dead stretch */
    ],
    endAt: 14.2
  },
  portrait: {
    dataId: 'heroFilmDataPortrait',
    beats: [
      { t: 0.60,  hold: 0.80 },
      { t: 5.20,  hold: 0.85 },
      { t: 6.30,  hold: 0.60 },
      { t: 7.80,  hold: 0.75 },
      { t: 9.50,  hold: 0.70 },
      { t: 10.30, hold: 0.70 },
      { t: 12.40, hold: 0.85 },
      { t: 15.80, hold: 0.80 }
    ],
    endAt: 14.2
  }
};
var TRAVEL_RATE = 0.30;       /* scroll-units per second of film between beats */

/* In the Shopify theme the beats are editable blocks, so DANCHEL_HERO (printed
   by the hero section) overrides the defaults above. Standalone builds have no
   such global and keep them. */
(function applyHeroConfig(){
  var C = window.DANCHEL_HERO;
  if(!C || !C.beats || !C.beats.length) return;
  FILMS.landscape.beats = C.beats.map(function(b){ return { t: +b.land, hold: +b.hold }; });
  FILMS.portrait.beats  = C.beats.map(function(b){ return { t: +b.port, hold: +b.hold }; });
  if(C.endAt != null){ FILMS.landscape.endAt = FILMS.portrait.endAt = +C.endAt; }
  if(C.travelRate != null){ TRAVEL_RATE = +C.travelRate; }
})();

/* pick the cut by viewport shape, not width, so a portrait tablet gets the
   portrait film and a phone held sideways gets the wide one */
var PORTRAIT_Q = window.matchMedia('(max-aspect-ratio: 3/4)');
var current = null, BEATS = [];

/* precompute the scroll timeline for whichever cut is loaded */
var TL = [], TOTAL = 0;
function buildTimeline(){
  TL = []; TOTAL = 0;
  for(var i=0;i<BEATS.length;i++){
    TL.push({kind:'hold', i:i, w:BEATS[i].hold});
    TOTAL += BEATS[i].hold;
    if(i < BEATS.length-1){
      var span = BEATS[i+1].t - BEATS[i].t;
      var w = span * TRAVEL_RATE;
      TL.push({kind:'run', i:i, w:w, span:span});
      TOTAL += w;
    }
  }
}

/* scroll progress 0..1 -> {time, beat, holding} */
function mapFilm(p){
  var acc = p * TOTAL;
  for(var s=0;s<TL.length;s++){
    var seg = TL[s];
    if(acc <= seg.w || s === TL.length-1){
      if(seg.kind === 'hold') return {time:BEATS[seg.i].t, beat:seg.i, holding:true};
      var k = seg.w ? (acc/seg.w) : 1;
      /* mid-travel the label flips to the beat being approached */
      return {time: BEATS[seg.i].t + k*seg.span,
              beat: k >= 0.5 ? seg.i+1 : seg.i, holding:false};
    }
    acc -= seg.w;
  }
  var last = BEATS.length-1;
  return {time:BEATS[last].t, beat:last, holding:true};
}

var filmReady = false, filmOK = true, targetT = 0.6, currentT = 0.6, filmRaf = null;

/* iOS Safari will not paint a frame from a seek until the element has decoded
   at least one frame through play(). muted + playsinline lets us do that
   silently; the 'play' guard below stands down while priming. */
var priming = false, primed = false;
function primeDecoder(){
  if(primed || reduced || !film) return;
  primed = true; priming = true;
  var settle = function(){
    requestAnimationFrame(function(){
      try{ film.pause(); }catch(e){}
      priming = false;
    });
  };
  try{
    var pr = film.play();
    if(pr && pr.then) pr.then(settle)['catch'](function(){ priming = false; primed = false; });
    else settle();
  }catch(e){ priming = false; primed = false; }
}
/* if the silent prime was refused, the first touch is a second chance */
['touchstart','pointerdown','scroll'].forEach(function(ev){
  window.addEventListener(ev, function(){ primeDecoder(); }, {passive:true});
});

function filmBoot(){
  if(filmReady) return;
  filmReady = true;
  heroBoot.classList.add('done');
  primeDecoder();
  seekLoop();
}

/* ---- source selection -------------------------------------------------
   Try the sibling file first (full resolution). If it isn't there — the page
   was opened on its own, emailed, dropped into a preview pane — decode the
   embedded copy into a Blob and use that instead. Either way the scrubbing
   below is identical.                                                     */
var usedInline = false, usedDataURI = false, inlineB64 = null;
function grabB64(){
  if(inlineB64 === null){
    var node = $(current.dataId);
    inlineB64 = node ? node.textContent.replace(/\s+/g,'') : '';
  }
  return inlineB64;
}
/* tier 2 — a Blob URL: cheap to seek, and the DOM stays light */
function attachInline(){
  if(usedInline) return false;
  usedInline = true;
  var s = grabB64();
  if(!s) return false;
  try{
    var bin = atob(s), n = bin.length, buf = new Uint8Array(n);
    for(var i=0;i<n;i++) buf[i] = bin.charCodeAt(i);
    film.src = URL.createObjectURL(new Blob([buf], {type: film.dataset.type || 'video/mp4'}));
    film.load();
    return true;
  }catch(e){ return false; }
}
/* tier 3 — a data: URI, for hosts whose policy blocks blob: media */
function attachDataURI(){
  if(usedDataURI) return false;
  usedDataURI = true;
  var s = grabB64();
  if(!s) return false;
  try{
    film.src = 'data:' + (film.dataset.type || 'video/mp4') + ';base64,' + s;
    film.load();
    return true;
  }catch(e){ return false; }
}
function filmFailed(){
  if(attachInline()) return;                     /* sibling file missing */
  if(attachDataURI()) return;                    /* blob: refused */
  filmOK = false;
  heroBoot.classList.add('done');
  heroCopy.classList.remove('faded');            /* poster + copy still read as a hero */
}

/* load (or reload, on rotation) the cut that suits the viewport */
function loadFilm(kind){
  if(current === FILMS[kind]) return;
  current = FILMS[kind];
  BEATS = current.beats;
  buildTimeline();

  var portrait = kind === 'portrait';
  var file   = portrait ? film.dataset.filmPortrait   : film.dataset.film;
  var poster = portrait ? film.dataset.posterPortrait : film.dataset.poster;

  filmReady = false; filmOK = true;
  usedInline = false; usedDataURI = false; inlineB64 = null;
  primed = false; priming = false;
  targetT = currentT = BEATS[0].t;

  if(poster) film.poster = poster;
  if(file){ film.src = file; film.load(); } else { attachInline(); }

  if(film.readyState >= 2) filmBoot();
  heroFrame();
}

if(film){
  film.addEventListener('loadeddata', filmBoot);
  film.addEventListener('canplay', filmBoot);
  /* we own the playhead — never let it run on its own */
  film.addEventListener('play', function(){ if(filmReady && !reduced && !priming) film.pause(); });
  film.addEventListener('error', filmFailed);

  loadFilm(PORTRAIT_Q.matches ? 'portrait' : 'landscape');

  /* rotating the device swaps the cut; scroll position re-derives the frame */
  var onShapeChange = function(){ loadFilm(PORTRAIT_Q.matches ? 'portrait' : 'landscape'); };
  if(PORTRAIT_Q.addEventListener) PORTRAIT_Q.addEventListener('change', onShapeChange);
  else if(PORTRAIT_Q.addListener) PORTRAIT_Q.addListener(onShapeChange);

  /* Some hosts swallow the error event for a missing file. If the sibling
     hasn't produced even metadata after 2.5s, treat it as absent — a real
     download reports readyState 1 well before that, thanks to faststart. */
  setTimeout(function(){
    if(filmReady || usedInline) return;
    if(film.readyState === 0) attachInline();
  }, 2500);
  setTimeout(function(){
    if(filmReady || usedDataURI) return;
    if(film.readyState === 0) attachDataURI();
  }, 6000);
  /* hard stop: never leave the loader sitting over the hero */
  setTimeout(function(){
    if(filmReady) return;
    if(film.readyState >= 2){ filmBoot(); return; }
    heroBoot.classList.add('done');
    heroCopy.classList.remove('faded');
  }, 11000);
}

function seekLoop(){
  filmRaf = null;
  if(!filmReady || !filmOK || reduced) return;
  /* ease toward the target so scrubbing feels weighted rather than twitchy */
  currentT += (targetT - currentT) * 0.14;
  if(Math.abs(targetT - currentT) < 0.004) currentT = targetT;
  try{
    if(Math.abs(film.currentTime - currentT) > 0.012){
      if(film.fastSeek) film.fastSeek(currentT); else film.currentTime = currentT;
    }
  }catch(e){}
  if(Math.abs(targetT - currentT) > 0.004) filmRaf = requestAnimationFrame(seekLoop);
}

var lastBeat = -1;
function heroFrame(){
  if(reduced || !heroTrack || !current) return;
  var r = heroTrack.getBoundingClientRect();
  var total = r.height - window.innerHeight;
  var p = Math.min(1, Math.max(0, -r.top / (total || 1)));

  var m = mapFilm(p);
  targetT = m.time;
  if(!filmRaf) filmRaf = requestAnimationFrame(seekLoop);

  /* one variable drives the rail: vertical on desktop, horizontal on mobile */
  heroBar.style.setProperty('--p', (p*100) + '%');

  if(m.beat !== lastBeat){
    lastBeat = m.beat;
    heroNum.textContent = ('0'+(m.beat+1)).slice(-2) + ' / ' + ('0'+BEATS.length).slice(-2);
  }
  chapEls.forEach(function(li,i){
    li.classList.toggle('on', i === m.beat);
    li.classList.toggle('hold', i === m.beat && m.holding);
  });

  /* the film carries its own typography from ~4s, so the overlay copy and the
     scrim step aside once the opening beat is over */
  var fade = Math.min(1, Math.max(0, (m.time - 1.4) / 2.4));
  heroCopy.classList.toggle('faded', fade > 0.5);
  heroScrim.style.opacity = String(1 - fade);

  var cueOff = p > 0.02;
  heroCue.style.opacity = cueOff ? 0 : 1;
  heroCue.style.visibility = cueOff ? 'hidden' : 'visible';
  heroEnd.classList.toggle('on', m.time > current.endAt);
}

/* ---------- Customer photos in the trust pill ----------
   Rendered from window.DANCHEL_CUSTOMER_PHOTOS (declared near the top of the
   hero markup). Empty list, or every image failing to load, leaves the stack
   hidden and the pill showing its text alone — nothing stands in for a real
   customer.                                                                */
(function renderTrustPhotos(){
  var host = $('trustDots');
  if(!host) return;
  var list = (window.DANCHEL_CUSTOMER_PHOTOS || []).filter(function(p){
    return p && typeof p.src === 'string' && p.src.trim();
  }).slice(0, 5);
  if(!list.length) return;

  list.forEach(function(p){
    var img = new Image();
    img.src = p.src;
    img.alt = p.alt || '';
    if(!img.alt) img.setAttribute('aria-hidden','true');
    img.loading = 'lazy';
    img.decoding = 'async';
    img.addEventListener('error', function(){
      img.remove();
      if(!host.children.length) host.hidden = true;
    });
    host.appendChild(img);
  });
  if(host.children.length) host.hidden = false;
})();

/* Hero headline entrance — skipped entirely when the hero isn't on the page */
if(heroL1 && heroL2){
  if(reduced){
    heroL1.classList.add('in'); heroL2.classList.add('in');
  }else{
    setTimeout(function(){ heroL1.classList.add('in'); }, 150);
    setTimeout(function(){ heroL2.classList.add('in'); }, 420);
  }
}

/* ---------- Burgundy section ----------
   Same pinned burgundy stage, halo and shine as before. The scroll now steps
   through four arguments for the stick format, cross-fading one at a time,
   with a rail underneath so they read as a set rather than a slideshow. The
   fifth and final slot is the closing line, at which point the whole rail
   lights up.                                                              */
var swipeTrack   = document.querySelector('.swipe-track');
var swipeHalo = $('swipeHalo'), swipeShine = $('swipeShine'), fmtRail = $('fmtRail');
var jarCard   = document.querySelector('.fmt-jar .fmt-card'),
    stickCard = document.querySelector('.fmt-stick .fmt-card');
var fmtItems = $('fmtStack') ? Array.prototype.slice.call($('fmtStack').children) : [],
    railEls  = fmtRail ? Array.prototype.slice.call(fmtRail.children) : [];

var FMT_START = 0.08,   /* first argument is already showing before this */
    FMT_SPAN  = 0.84;   /* the five slots share this much of the track */

function swipeFrame(){
  if(!swipeTrack || reduced || !fmtItems.length) return;
  var r = swipeTrack.getBoundingClientRect();
  if(r.bottom <= 0 || r.top >= window.innerHeight) return;

  var total = r.height - window.innerHeight;
  var p = Math.min(1, Math.max(0, -r.top / (total || 1)));

  if(swipeHalo)  swipeHalo.style.transform = 'scale(' + (0.8 + p*.5) + ')';
  if(swipeShine) swipeShine.style.left = (-50 + p*200) + '%';
  /* counter-parallax: over the section the jar settles back and the stick
     rises, so the argument is happening in the picture as well as the text */
  if(jarCard){
    jarCard.style.transform = 'translateY(' + (p*14) + 'px) scale(' + (1 - p*.06) + ')';
    jarCard.style.opacity = String(0.78 - p*0.2);
  }
  if(stickCard){
    stickCard.style.transform = 'translateY(' + (-p*12) + 'px) scale(' + (1 + p*.06) + ')';
  }

  var n = fmtItems.length, step = FMT_SPAN / n;
  var idx = Math.floor((p - FMT_START) / step);
  idx = Math.max(0, Math.min(n - 1, idx));

  fmtItems.forEach(function(el, i){ el.classList.toggle('on', i === idx); });
  railEls.forEach(function(li, i){ li.classList.toggle('on', i === idx); });
  /* the closing slot has no rail entry of its own — light them all instead */
  if(fmtRail) fmtRail.classList.toggle('all', idx === n - 1);
}

var ticking = false;
function onScroll(){
  if(ticking) return;
  ticking = true;
  requestAnimationFrame(function(){ heroFrame(); swipeFrame(); stickyFrame(); ticking = false; });
}
window.addEventListener('scroll', onScroll, {passive:true});
window.addEventListener('resize', onScroll);
onScroll();

/* ---------- Application hotspots ----------
   The title and body copy for each zone live on the card itself
   (data-title / data-text), so every zone is editable from the theme
   editor without touching this file. */
var applyTitle = $('applyTitle'), applyText = $('applyText');
document.querySelectorAll('.apply-card').forEach(function(card){
  card.addEventListener('click', function(){
    document.querySelectorAll('.apply-card').forEach(function(c){ c.setAttribute('aria-selected','false'); c.style.borderColor=''; });
    card.setAttribute('aria-selected','true');
    card.style.borderColor = 'var(--burgundy)';
    if(applyTitle) applyTitle.textContent = card.getAttribute('data-title') || '';
    if(applyText)  applyText.textContent  = card.getAttribute('data-text')  || '';
  });
});

/* ---------- Before / After slider ---------- */
var baRange = $('baRange'), baAfterWrap = $('baAfterWrap'), baDivider = $('baDivider'), baHandle = $('baHandle');
function setBA(v){
  if(!baAfterWrap || !baDivider || !baHandle) return;
  baAfterWrap.style.clipPath = 'inset(0 0 0 ' + v + '%)';
  baDivider.style.left = v + '%';
  baHandle.style.left = v + '%';
}
if(baRange){
  baRange.addEventListener('input', function(){ setBA(baRange.value); });
  setBA(50);
}

/* ---------- UGC rail ---------- */
var rail = $('ugcRail');
function railStep(dir){
  if(!rail) return;
  rail.scrollBy({left: dir * (rail.clientWidth * .7), behavior: reduced ? 'auto' : 'smooth'});
}
on($('ugcPrev'), 'click', function(){ railStep(-1); });
on($('ugcNext'), 'click', function(){ railStep(1); });

/* ---------- Bundles & cart ----------
   Every bundle is read off its own element rather than hardcoded here, so
   adding, removing, renaming or repricing a bundle is a theme-editor job.
   Each `.bundle` carries:
     data-bundle  unique key      data-price  number
     data-name    cart line name  data-label  short label for the sticky bar
     data-variant-id       the Shopify variant Add to Bag actually posts
     data-selling-plan-id  its subscription plan, when it has one of its own
   `SUB_RATE` comes from the section's Subscribe & Save setting. */
var bundles = {}, bundleOrder = [], selected = '', plan = 'once';
document.querySelectorAll('.bundle').forEach(function(el){
  var k = el.getAttribute('data-bundle');
  if(!k) return;
  bundles[k] = {
    name:  el.getAttribute('data-name')  || k,
    label: el.getAttribute('data-label') || el.getAttribute('data-name') || k,
    price: parseFloat(el.getAttribute('data-price')) || 0,
    /* how many sticks the bundle contains, and the compare-at price — both
       optional, both only used for display */
    units: parseInt(el.getAttribute('data-units'), 10) || 1,
    compareAt: parseFloat(el.getAttribute('data-compare')) || 0,
    /* what makes this bundle sellable — see addToBag() */
    variantId: (el.getAttribute('data-variant-id') || '').trim(),
    sellingPlanId: (el.getAttribute('data-selling-plan-id') || '').trim()
  };
  bundleOrder.push(k);
  if(el.classList.contains('selected')) selected = k;
});
var SUB_RATE = (function(){
  var r = (window.DANCHEL_OFFER || {}).subRate;
  return r == null ? 0.15 : (+r > 1 ? +r / 100 : +r);
})();
if(!selected) selected = bundleOrder[0];
/* an empty bundle list would make every price lookup throw — one inert
   placeholder keeps the rest of the page alive if the section is removed */
if(!bundleOrder.length){ bundles.__none = {name:'', label:'', price:0}; selected = '__none'; }
function money(n){ return '$' + n.toFixed(2); }
function priceOf(key, forPlan){
  var p = bundles[key].price;
  return (forPlan || plan) === 'sub' ? p * (1 - SUB_RATE) : p;
}
/* The bag is Shopify's, not ours: `serverCart` is the last /cart.js response
   and the drawer is drawn from it. There is deliberately no local basket — a
   page that keeps its own is a page that can check out with an empty cart. */
var serverCart = null, cartBusy = false;
var atbPrice = $('atbPrice'), stickyPrice = $('stickyPrice');

/* The per-unit line on each card is written here rather than in Liquid, so
   there is exactly one implementation of money formatting on the page. It
   is an enhancement: without it the card still shows its real price. */
document.querySelectorAll('.bundle').forEach(function(el){
  var each = el.querySelector('.bundle-each');
  if(!each) return;
  var k = el.getAttribute('data-bundle');
  var b = bundles[k];
  if(!b || !b.units || b.units < 2) return;
  each.textContent = money(b.price / b.units) + ' each';
});

document.querySelectorAll('.bundle').forEach(function(b){
  b.addEventListener('click', function(){
    document.querySelectorAll('.bundle').forEach(function(x){ x.classList.remove('selected'); });
    b.classList.add('selected');
    b.querySelector('input').checked = true;
    selected = b.dataset.bundle;
    refreshPrices();
  });
});

/* one-time vs subscription — the 15% applies to whichever bundle is chosen */
document.querySelectorAll('.plan').forEach(function(el){
  el.addEventListener('click', function(){
    document.querySelectorAll('.plan').forEach(function(x){ x.classList.remove('selected'); });
    el.classList.add('selected');
    el.querySelector('input').checked = true;
    plan = el.dataset.plan;
    refreshPrices();
  });
});

/* ---------- quantity ---------- */
var qty = 1;
function clampN(v,a,b){ return Math.max(a, Math.min(b, v)); }
function setQty(n){
  qty = clampN(Math.round(n) || 1, 1, 12);
  var input = $('qtyInput');
  if(input) input.value = qty;
  refreshPrices();
}
on($('qtyMinus'), 'click', function(){ setQty(qty - 1); });
on($('qtyPlus'),  'click', function(){ setQty(qty + 1); });
on($('qtyInput'), 'change', function(e){ setQty(parseInt(e.target.value, 10)); });

function refreshPrices(){
  var b = bundles[selected] || {price:0, units:1, label:''};
  var once = priceOf(selected, 'once'), sub = priceOf(selected, 'sub');
  var set = function(id, txt){ var el = $(id); if(el) el.textContent = txt; };

  if(atbPrice) atbPrice.textContent = money(priceOf(selected) * qty);
  /* On a product template there are no bundle cards — the buy box owns the
     price and reads it off the real variant. Writing a placeholder here would
     put "$0.00" on the sticky bar, so the label is left empty instead. */
  if(stickyPrice) stickyPrice.textContent = bundleOrder.length
    ? b.label + ' · ' + money(priceOf(selected)) + (plan === 'sub' ? ' / 30 days' : '')
    : '';
  set('planOncePrice', money(once));
  set('planSubPrice',  money(sub));
  set('priceNow', money(priceOf(selected)));

  /* per-unit price — only meaningful when the section says how many sticks
     a bundle contains */
  var unitEl = $('priceUnit');
  if(unitEl){
    var size = unitEl.getAttribute('data-size') || '';
    unitEl.textContent = money(priceOf(selected) / (b.units || 1)) +
                         ' per stick' + (size ? ' · ' + size + ' each' : '');
  }

  /* the compare-at price and the saving both disappear rather than showing a
     strike-through of the same number */
  var was = $('priceWas'), save = $('priceSave');
  var savings = (b.compareAt > b.price ? b.compareAt - b.price : 0) +
                (plan === 'sub' ? b.price * SUB_RATE : 0);
  if(was){
    if(b.compareAt > b.price){ was.textContent = money(b.compareAt); was.hidden = false; }
    else was.hidden = true;
  }
  if(save){
    if(savings > 0.005){ save.textContent = 'Save ' + money(savings); save.hidden = false; }
    else save.hidden = true;
  }
}
refreshPrices();

var cart = $('cart'), cartVeil = $('cartVeil'), cartBody = $('cartBody'),
    cartTotal = $('cartTotal'), bagCount = $('bagCount'), toast = $('toast');
function setCart(open){
  if(!cart || !cartVeil) return;
  cart.classList.toggle('open', open);
  cartVeil.classList.toggle('open', open);
  cart.setAttribute('aria-hidden', String(!open));
}
on($('bagBtn'), 'click', function(){ setCart(true); });
on($('cartClose'), 'click', function(){ setCart(false); });
on(cartVeil, 'click', function(){ setCart(false); });

/* the offer section owns the thumbnail; fall back to a transparent pixel */
function cartThumb(){
  var im = document.querySelector('.buy-media img');
  return im ? im.src : 'data:image/gif;base64,R0lGODlhAQABAAAAACH5BAEKAAEALAAAAAABAAEAAAICTAEAOw==';
}
function showToast(msg){
  if(!toast || !msg) return;
  toast.textContent = msg;
  toast.classList.add('show');
  clearTimeout(showToast.t);
  showToast.t = setTimeout(function(){ toast.classList.remove('show'); }, 2400);
}

/* ---------- the real Shopify bag ----------
   Every line in the drawer comes from /cart.js and every change goes back
   through Shopify's own endpoints, so the drawer, the header count and the
   checkout can never disagree. `money()` above still formats the typed bundle
   prices; cart amounts arrive in cents with their own currency, so they are
   formatted from that instead of assuming dollars. */
var BAG = window.DANCHEL_BAG || {};
function cartMoney(cents){
  var code = (serverCart && serverCart.currency) || 'USD';
  var n = (cents || 0) / 100;
  try{
    return new Intl.NumberFormat(document.documentElement.lang || undefined,
      { style:'currency', currency: code }).format(n);
  }catch(e){ return n.toFixed(2) + ' ' + code; }
}
function paintCount(){
  var n = serverCart ? serverCart.item_count : 0;
  if(bagCount) bagCount.textContent = n;
  document.querySelectorAll('.bag-count,[data-bag-count]').forEach(function(el){
    el.textContent = n;
  });
}
function renderCart(){
  if(!cartBody) return;
  var items = (serverCart && serverCart.items) || [];
  cartBody.innerHTML = '';
  if(!items.length){
    var empty = document.createElement('p');
    empty.className = 'cart-empty';
    empty.textContent = BAG.empty || '';
    cartBody.appendChild(empty);
  }
  items.forEach(function(it, i){
    var el = document.createElement('div');
    el.className = 'cart-item';
    el.innerHTML =
      '<img alt="">' +
      '<div><h3></h3><p class="ci-meta"></p>' +
      '<span class="ci-qty">' +
        '<button type="button" data-line="' + (i+1) + '" data-d="-1">−</button>' +
        '<span></span>' +
        '<button type="button" data-line="' + (i+1) + '" data-d="1">+</button>' +
      '</span></div>' +
      '<span class="ci-price"></span>';
    var img = el.querySelector('img');
    img.src = (it.featured_image && it.featured_image.url) || it.image || cartThumb();
    /* the line title is right beside it, so the thumbnail is decorative */
    img.alt = '';
    el.querySelector('h3').textContent = it.product_title || it.title || '';
    /* the variant and the plan name are Shopify's own words for this line —
       nothing is written here that the order confirmation will not repeat */
    var meta = [];
    if(it.variant_title && it.variant_title !== 'Default Title') meta.push(it.variant_title);
    if(it.selling_plan_allocation && it.selling_plan_allocation.selling_plan){
      meta.push(it.selling_plan_allocation.selling_plan.name);
    }
    el.querySelector('.ci-meta').textContent = meta.join(' · ');
    var btns = el.querySelectorAll('.ci-qty button');
    btns[0].setAttribute('aria-label', BAG.qtyDown || '');
    btns[1].setAttribute('aria-label', BAG.qtyUp || '');
    el.querySelector('.ci-qty > span').textContent = it.quantity;
    el.querySelector('.ci-price').textContent =
      cartMoney(it.final_line_price != null ? it.final_line_price : it.line_price);
    cartBody.appendChild(el);
  });
  cartBody.querySelectorAll('.ci-qty button').forEach(function(btn){
    btn.addEventListener('click', function(){
      var line = parseInt(btn.getAttribute('data-line'), 10);
      var it = ((serverCart && serverCart.items) || [])[line - 1];
      if(!it) return;
      changeLine(line, it.quantity + Number(btn.getAttribute('data-d')));
    });
  });
  if(cartTotal) cartTotal.textContent = cartMoney(serverCart ? serverCart.total_price : 0);
  paintCount();
}
/* read the cart back after anything that could have changed it */
function refreshCart(open){
  if(!window.fetch) return;
  fetch('/cart.js', { headers:{'Accept':'application/json'} })
    .then(function(r){ return r.ok ? r.json() : null; })
    .then(function(c){
      /* paintCount() is called here as well as inside renderCart(): the header
         count has to be right even on a page with no bag drawer on it */
      if(c){ serverCart = c; paintCount(); renderCart(); }
      if(open) setCart(true);
    })
    ['catch'](function(){ /* no cart endpoint (a preview, an outage) — leave the drawer as it is */ });
}
function changeLine(line, quantity){
  if(cartBusy || !window.fetch) return;
  cartBusy = true;
  fetch('/cart/change.js', {
    method:'POST',
    headers:{'Content-Type':'application/json','Accept':'application/json'},
    body: JSON.stringify({ line: line, quantity: Math.max(0, quantity) })
  })
    .then(function(r){ if(!r.ok) throw new Error('cart/change'); return r.json(); })
    .then(function(c){ serverCart = c; renderCart(); })
    ['catch'](function(err){
      console.error('[Danchel Bag] /cart/change.js failed:', err);
      showToast(BAG.error || '');
    })
    .then(function(){ cartBusy = false; });
}

/* ---------- Add to Bag ----------
   Posts the selected bundle's variant to Shopify. A bundle with no variant id
   is not sellable, and this refuses rather than drawing a bag that checkout
   knows nothing about. */
function offerCfg(){ return window.DANCHEL_OFFER || {}; }
/* the same fallback the product buy box uses: if the JSON call fails for any
   reason, post the add as an ordinary form so a failure costs a page load
   rather than the sale */
function postAddForm(variantId, planId){
  var f = document.createElement('form');
  f.method = 'post';
  f.action = '/cart/add';
  f.style.display = 'none';
  var add = function(name, value){
    var i = document.createElement('input');
    i.type = 'hidden'; i.name = name; i.value = value;
    f.appendChild(i);
  };
  add('id', variantId);
  add('quantity', qty);
  if(planId) add('selling_plan', planId);
  document.body.appendChild(f);
  f.submit();
}
function addToBag(e){
  var CFG = offerCfg();
  var b = bundles[selected] || {};
  var variantId = (b.variantId || '').trim();

  if(!variantId){
    console.error('[Danchel Offer] Bundle "' + (b.name || selected) + '" has no variant id, ' +
      'so nothing can be added to the cart. Set it in Customize → Danchel Offer → ' +
      'this Bundle block → Variant ID.');
    showToast(CFG.missingVariant || '');
    return;
  }

  var planId = '';
  if(plan === 'sub') planId = b.sellingPlanId || CFG.sellingPlanId || '';

  if(!window.fetch){ postAddForm(variantId, planId); return; }

  var btn = e && e.currentTarget;
  if(btn) btn.classList.add('is-busy');
  var item = { id: variantId, quantity: qty };
  if(planId) item.selling_plan = planId;

  fetch('/cart/add.js', {
    method:'POST',
    headers:{'Content-Type':'application/json','Accept':'application/json'},
    body: JSON.stringify({ items: [item] })
  })
    .then(function(r){ return r.json().then(function(j){ return {ok:r.ok, body:j}; }); })
    .then(function(res){
      if(!res.ok) throw new Error((res.body && res.body.description) || 'cart/add');
      showToast(CFG.addedText || '');
      refreshCart(true);
    })
    ['catch'](function(err){
      console.error('[Danchel Offer] /cart/add.js failed:', err);
      showToast(CFG.errorText || '');
      postAddForm(variantId, planId);
    })
    .then(function(){ if(btn) btn.classList.remove('is-busy'); });
}
on($('atbBtn'), 'click', addToBag);
/* On a product template the buy box is the thing that can actually sell, so
   the sticky bar presses its button rather than guessing at a bundle. */
on($('stickyAtb'), 'click', function(e){
  var pdpAdd = document.querySelector('[data-atb]');
  if(pdpAdd){ pdpAdd.click(); return; }
  addToBag(e);
});

/* the buy box on the product template posts its own form and announces it —
   pick that up so the drawer and the count follow it too */
document.addEventListener('dch:cart:added', function(){ refreshCart(true); });

/* Shopify's own cart page is the default destination; the Bag section's
   "Checkout link" is an override for stores that send people elsewhere. */
on($('checkoutBtn'), 'click', function(e){
  var url = (e.currentTarget.getAttribute('data-checkout-url') || BAG.checkoutUrl || '').trim();
  window.location.href = url || '/cart';
});
renderCart();
refreshCart(false);

/* ---------- Sticky mobile CTA ---------- */
var stickyCta = $('stickyCta');
/* the offer section's anchor id is editable, so fall back to finding it by
   its markup rather than assuming it is still called "buy" */
var buyGrid = document.querySelector('.buy-grid') || document.querySelector('.pdp-grid');
var buySection = $('buy') || (buyGrid && buyGrid.closest ? buyGrid.closest('section') : null) || buyGrid;
var footEl = document.querySelector('.footer');
function stickyFrame(){
  if(!stickyCta || !buySection) return;
  var heroGone = heroTrack ? heroTrack.getBoundingClientRect().bottom < window.innerHeight * .5 : true;
  var buyR = buySection.getBoundingClientRect();
  var overBuy = buyR.top < window.innerHeight && buyR.bottom > 0;
  var beforeFooter = footEl ? footEl.getBoundingClientRect().top > window.innerHeight : true;
  stickyCta.classList.toggle('show', heroGone && !overBuy && beforeFooter);
}

/* ---------- Magnetic buttons ---------- */
if(!reduced && window.matchMedia('(hover:hover)').matches){
  document.querySelectorAll('[data-magnet]').forEach(function(btn){
    btn.addEventListener('mousemove', function(e){
      var r = btn.getBoundingClientRect();
      var x = (e.clientX - r.left - r.width/2) * .12;
      var y = (e.clientY - r.top - r.height/2) * .18;
      btn.style.transform = 'translate(' + x + 'px,' + y + 'px)';
    });
    btn.addEventListener('mouseleave', function(){ btn.style.transform = ''; });
  });
}

/* ---------- Newsletter ---------- */
on($('newsForm'), 'submit', function(e){
  e.preventDefault();
  showToast('Welcome to the Glow — you’re on the list.');
  e.target.reset();
});

/* ---------- Offer block: payments, timeline, review, clips ----------
   All four render from window.DANCHEL_OFFER (declared above the purchase
   section). The timeline and payment list are your own policy, so they
   always render. The review and the clips render ONLY when real content
   has been supplied — empty means the module stays out of the page.     */
(function offerBlock(){
  var CFG = window.DANCHEL_OFFER || {};

  var ICON = {
    check: '<svg viewBox="0 0 24 24"><path d="m5 12.5 4.5 4.5L19 7.5"/></svg>',
    pack:  '<svg viewBox="0 0 24 24"><path d="M4 8h16v11a1 1 0 0 1-1 1H5a1 1 0 0 1-1-1z"/><path d="M3 5h18v3H3zM10 12h4"/></svg>',
    ship:  '<svg viewBox="0 0 24 24"><path d="M3 7h11v9H3zM14 10h4l3 3v3h-7"/><circle cx="7" cy="18" r="1.7"/><circle cx="17.5" cy="18" r="1.7"/></svg>',
    home:  '<svg viewBox="0 0 24 24"><path d="M4 11l8-6 8 6"/><path d="M6 10v9h12v-9"/></svg>',
    star:  '<svg viewBox="0 0 24 24"><path d="M12 3l2.7 5.6 6.1.8-4.5 4.2 1.1 6-5.4-3-5.4 3 1.1-6L3.2 9.4l6.1-.8L12 3Z"/></svg>',
    play:  '<svg viewBox="0 0 24 24"><path d="M7 4.5v15l13-7.5-13-7.5Z"/></svg>',
    person:'<svg viewBox="0 0 24 24"><circle cx="12" cy="8" r="3.4"/><path d="M5.5 20a6.5 6.5 0 0 1 13 0"/></svg>'
  };
  var STEP_ICONS = [ICON.check, ICON.pack, ICON.ship, ICON.home];

  /* payment methods */
  var payRow = $('payRow');
  if(payRow && CFG.payments && CFG.payments.length){
    CFG.payments.forEach(function(pm){
      /* a string is a typographic fallback; an object with `src` uses the
         brand's own artwork */
      var name = typeof pm === 'string' ? pm : (pm && pm.name) || '',
          src  = typeof pm === 'string' ? '' : (pm && pm.src) || '';
      if(!name && !src) return;
      var li = document.createElement('li');
      if(src){
        li.className = 'pay-img';
        var img = new Image();
        img.alt = name;
        img.decoding = 'async';
        /* If the asset is missing, fall back to the wordmark rather than
           leaving a broken image in the checkout trust row. The listener is
           attached BEFORE src so a synchronous failure can't slip past it,
           and these are not lazy-loaded — a payment badge that only appears
           after you scroll to it is doing no reassurance work. */
        img.addEventListener('error', function(){
          li.className = '';
          li.textContent = name;
        });
        img.src = src;
        li.appendChild(img);
      }else{
        li.textContent = name;
      }
      payRow.appendChild(li);
    });
  }else if(payRow){
    var pb = payRow.closest ? payRow.closest('.pay-block') : null;
    if(pb) pb.hidden = true;
  }

  /* fulfilment timeline */
  var tl = $('tlSteps');
  if(tl && CFG.timeline && CFG.timeline.length){
    CFG.timeline.forEach(function(step, i){
      var li = document.createElement('li');
      if(step.done) li.className = 'done';
      li.innerHTML =
        '<span class="tl-mark" aria-hidden="true">' + (STEP_ICONS[i] || ICON.check) + '</span>' +
        '<span class="tl-label"></span><span class="tl-meta"></span>';
      li.querySelector('.tl-label').textContent = step.label || '';
      li.querySelector('.tl-meta').textContent  = step.meta  || '';
      tl.appendChild(li);
    });
  }

  /* subscription milestone gift */
  var giftEl = $('planGift');
  if(giftEl && CFG.subscriptionGift){
    giftEl.innerHTML =
      '<svg viewBox="0 0 24 24" aria-hidden="true"><path d="M4 11h16v9H4zM3 7h18v4H3zM12 7v13"/>' +
      '<path d="M12 7S10.5 3.5 8.5 4.2 8 7 12 7ZM12 7s1.5-3.5 3.5-2.8S16 7 12 7Z"/></svg>' +
      '<span></span>';
    giftEl.querySelector('span').textContent = CFG.subscriptionGift;
    giftEl.hidden = false;
  }

  /* featured review — only with real content */
  var rv = CFG.featuredReview, rvEl = $('offerReview');
  if(rvEl && rv && rv.quote){
    var n = Math.max(0, Math.min(5, rv.stars || 5));
    var stars = '';
    for(var i=0;i<n;i++) stars += ICON.star;
    var avatar = rv.photo
      ? '<span class="or-avatar"><img src="' + rv.photo + '" alt=""></span>'
      : '<span class="or-avatar" aria-hidden="true">' + ICON.person + '</span>';
    rvEl.innerHTML = avatar +
      '<div><div class="or-stars" aria-hidden="true">' + stars + '</div>' +
      '<blockquote></blockquote>' +
      '<figcaption class="or-by"><span class="or-check" aria-hidden="true">' +
      '<svg viewBox="0 0 24 24"><path d="m5 12.5 4.5 4.5L19 7.5"/></svg></span>' +
      '<strong></strong><span class="or-loc"></span></figcaption></div>';
    rvEl.querySelector('blockquote').textContent = rv.quote;
    rvEl.querySelector('.or-by strong').textContent = rv.name || '';
    rvEl.querySelector('.or-loc').textContent = rv.location ? ' · ' + rv.location : '';
    rvEl.hidden = false;
  }

  /* customer clips — only with real content */
  var clips = (CFG.ugc || []).filter(function(c){ return c && c.poster; }).slice(0,3),
      ugcEl = $('offerUgc'), ugcRow = $('offerUgcRow');
  if(ugcEl && ugcRow && clips.length){
    clips.forEach(function(c){
      var li = document.createElement('li');
      var inner =
        '<img src="' + c.poster + '" alt="' + (c.caption || 'Customer clip') + '" loading="lazy">' +
        '<span class="play" aria-hidden="true">' + ICON.play + '</span>' +
        '<span class="cap"></span>';
      if(c.href){
        var a = document.createElement('a');
        a.href = c.href; a.rel = 'noopener'; a.target = '_blank';
        a.innerHTML = inner; li.appendChild(a);
      }else{
        var d = document.createElement('span');
        d.className = 'still'; d.innerHTML = inner; li.appendChild(d);
      }
      li.querySelector('.cap').textContent = c.caption || '';
      ugcRow.appendChild(li);
    });
    ugcEl.hidden = false;
  }
})();



/* ============================================================================
   BLUSH GLASS — the motion layer

   Added when the homepage moved onto the product page's material system.
   Everything here is decoration over markup that already reads correctly, and
   every component tolerates its section being absent — which in a theme is
   the normal case, not the exception.
   ========================================================================== */
(function glassLayer(){
  var $$g = function(sel){ return Array.prototype.slice.call(document.querySelectorAll(sel)); };
  var canHover = window.matchMedia('(hover: hover) and (pointer: fine)').matches;

  /* ---------- the ground ----------
     Injected rather than put in a section: a Shopify section renders in
     isolation and cannot know whether another one already drew this, so
     markup would give us one ground per section. */
  if(!document.querySelector('.glass-ground')){
    var g = document.createElement('div');
    g.className = 'glass-ground';
    g.setAttribute('aria-hidden','true');
    g.innerHTML = '<i></i><i></i><i></i>';
    var grain = document.createElement('div');
    grain.className = 'grain';
    grain.setAttribute('aria-hidden','true');
    document.body.insertBefore(grain, document.body.firstChild);
    document.body.insertBefore(g, document.body.firstChild);
  }

  /* ---------- the sticky top stack ----------
     The announcement bar stays on screen and the header parks directly under
     it. The bar's height is measured rather than assumed: it stacks onto two
     lines on a phone, and the header would either overlap it or float below it
     if this were a constant. With no bar on the page the offset is zero, so the
     header sits at the top on its own. */
  (function announceOffset(){
    var bar = document.querySelector('.announce');
    var root = document.documentElement;
    if(!bar){ root.style.setProperty('--announce-h', '0px'); return; }
    function measure(){
      root.style.setProperty('--announce-h', Math.round(bar.getBoundingClientRect().height) + 'px');
    }
    measure();
    if(window.ResizeObserver) new ResizeObserver(measure).observe(bar);
    else on(window, 'resize', measure);
  })();

  /* ---------- split-line headings ----------
     The heading is legible before this runs and stays legible if it never
     does: the script adds `.armed`, which is what hides the lines, and the
     observer adds `.in`, which brings them back. */
  function buildLines(h){
    if(h.querySelector('.ln')) return;
    var parts = h.innerHTML.split(/<br\s*\/?>/i);
    h.innerHTML = parts.map(function(frag){
      return '<span class="ln"><span>' + frag + '</span></span>';
    }).join('');
  }
  if(!reduced){
    $$g('.split').forEach(function(h){
      buildLines(h);
      Array.prototype.forEach.call(h.querySelectorAll('.ln > span'), function(sp, i){
        sp.style.setProperty('--i', i);
      });
      h.classList.add('armed');
    });
  }

  $$g('.stagger').forEach(function(grp){
    Array.prototype.forEach.call(grp.children, function(child, i){
      child.style.setProperty('--i', i);
    });
  });

  /* threshold:0 with a bottom inset, never a percentage: a panel taller than
     the viewport can never satisfy "10% of it is visible", and stays blank */
  var gio = new IntersectionObserver(function(entries){
    entries.forEach(function(en){
      /* already scrolled past — a deep link or a restored scroll position.
         Nothing will scroll it into view again, so reveal it on the spot. */
      var passed = !en.isIntersecting && en.boundingClientRect.bottom < 0;
      if(en.isIntersecting || passed){
        en.target.classList.add('in');
        gio.unobserve(en.target);
      }
    });
  }, {threshold:0, rootMargin:'0px 0px -70px 0px'});
  $$g('.stagger, .split').forEach(function(el){ gio.observe(el); });

  /* ---------- specular ----------
     Pointer-fine only: on a touch screen there is no cursor for a highlight
     to track, and the work is wasted. */
  if(canHover && !reduced){
    $$g('.spec').forEach(function(el){
      on(el, 'pointermove', function(e){
        var r = el.getBoundingClientRect();
        el.style.setProperty('--mx', ((e.clientX - r.left) / r.width * 100).toFixed(1) + '%');
        el.style.setProperty('--my', ((e.clientY - r.top) / r.height * 100).toFixed(1) + '%');
      });
    });
  }

  /* ---------- read progress ---------- */
  var bar = $('readBar');
  if(bar){
    var ticking = false;
    var frame = function(){
      ticking = false;
      var h = document.documentElement.scrollHeight - window.innerHeight;
      bar.style.setProperty('--read', h > 0 ? Math.min(1, window.scrollY / h).toFixed(4) : 0);
    };
    on(window, 'scroll', function(){
      if(ticking) return;
      ticking = true;
      requestAnimationFrame(frame);
    }, {passive:true});
    on(window, 'resize', frame);
    frame();
  }
})();

})();
